import { ICartSession } from "../typings/interfaces/pos/cart-session";

// A ticket is ready for check-in once it has a pin tag colour and every tag
// slot is filled. Adding items after a tag was picked appends blank slots
// (cartAction.ts resizePinTagForSession), so a non-empty tag list can still
// be incomplete.
export const needsPinTag = (session?: ICartSession | null): boolean => {
  const pinTag = session?.pinTag;
  if (!pinTag?.color) return true;
  const tags = pinTag.tags ?? [];
  return tags.length === 0 || tags.some((tag) => !tag);
};

/** The first ticket in the cart still missing a pin tag, if any. */
export const firstSessionNeedingPinTag = (
  cart: ICartSession[]
): ICartSession | undefined =>
  cart.find(
    (session) =>
      session.cartItems?.some((item) => item.finalized) && needsPinTag(session)
  );
